__turbopack_context__.v({
  "queries": "Rvq10W_queries",
});
